module.exports = __webpack_public_path__ + "static/media/Week12_2.7d4d4e0d.pdf";